import React from 'react';
import waitingTermsStyles from '../../styles/estilos/waitingTerms.module.css';
import logoPng from '../../images/Frame.png';

const Loader = () => {
  return (
    <div className={waitingTermsStyles.messageContainer}>
      <img src={logoPng} alt="littleBlueLogo" className={waitingTermsStyles.img} />
      <h3 className="text-muted">CARGANDO...</h3>
      <div className={waitingTermsStyles.loader}></div>
    </div>
  );
};

export default Loader;
